import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureSqlMILinkedService } from 'app/model/linkedservice/azure-sql-mi.linkedservice';
import { AzureSqlLinkedServiceAdapter } from './azure-sql-linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { AdapterContext, AzureKeyVault, CredentialTypeOptions, ITridentResource, SQLAuthenticationType, sqlAdditionalPropertiesAdapts } from 'shell-models-lib';
import { DbConnectionStringBuilderService } from 'app/services/db-connection-string-builder.service';

const sqlMIV1Adapts = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    connectionString: (_context: AdapterContext, _value: any, ls: AzureSqlMILinkedService) => {
        // when AKV is used for connection string, it is already well handled. So we don't need handle it.
        // won't cover fully by json for now
        if (ls && !ls.fullyByJsonEditor && !ls.enableAKV) {
            if (ls.authenticationType === SQLAuthenticationType.SQL && ls.password instanceof AzureKeyVault) {
                return '*';
            }
            if (ls.authenticationType === SQLAuthenticationType.ManagedServiceIdentity
                || ls.authenticationType === SQLAuthenticationType.Credential
                || ls.authenticationType === SQLAuthenticationType.UserAssignedManagedIdentity) {
                return '*';
            }
            if (ls.authenticationType === SQLAuthenticationType.ServicePrincipal
                && (ls.servicePrincipalKey instanceof AzureKeyVault || (ls.credential != null && ls.credential.getType() === CredentialTypeOptions.ServicePrincipal))) {
                return '*';
            }
        }
        return 'secret';
    },
    servicePrincipalKey: 'secret'
};

const sqlMIV2Adapts = {
    server: '*',
    database: '*',
    userName: '*',
    encrypt: '*',
    trustServerCertificate: '*',
    hostNameInCertificate: '*',
    authenticationType: '*',
    servicePrincipalCredential: 'secret',
    ...sqlAdditionalPropertiesAdapts
};

const sharedAdapts = {
    password: 'secret',
    encryptedCredential: '*',
    servicePrincipalId: '*',
    tenant: '*',
    azureCloudType: '*',
    credential: '*',
    alwaysEncryptedSettings: {
        alwaysEncryptedAkvAuthType: '*',
        servicePrincipalId: '*',
        servicePrincipalKey: 'secret',
        credential: '*'
    }
};

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlMILinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                ...sharedAdapts,
                ...sqlMIV1Adapts,
                ...sqlMIV2Adapts
            },
            parameters: '*'
        }
    }
})
export class AzureSqlMILinkedServiceAdapter extends AzureSqlLinkedServiceAdapter {
    protected modelConstructor(): new () => AzureSqlMILinkedService {
        return AzureSqlMILinkedService;
    }

    protected model(): IModel {
        return AzureSqlMILinkedService.MODEL;
    }

    protected toAzureTypeProperties(tridentResource: ITridentResource) {
        let result = super.toAzureTypeProperties(tridentResource) || {};

        try {
            const { extensionDataSourcePath } = JSON.parse(tridentResource.connectionDetails);
            const [server, database] = extensionDataSourcePath.split(';');
            const builder = new DbConnectionStringBuilderService();
            if (result.connectionString) {
                builder.parse(result.connectionString);
            }
            builder.add('Data Source', server);
            builder.add('Initial Catalog', database);
            result.connectionString = builder.connectionString;
        } catch (error) {
            result = undefined;
        }
        return result;
    }
}
